import React from 'react';
import { StarIcon } from 'lucide-react';
export function Reviews() {
  const reviews = [{
    name: 'Sarah Jenkins',
    location: 'Alexandria, VA',
    text: 'My tire blew out on 495 during rush hour. Uzoma Towing was there in 15 minutes. The driver was incredibly professional and had me back on the road safely.',
    rating: 5
  }, {
    name: 'Marcus T.',
    location: 'Washington, DC',
    text: "The digital dispatch is a game changer. I didn't have to wait on hold, just clicked a button and could track the truck on my phone. Highly recommend!",
    rating: 5
  }, {
    name: 'Emily Chen',
    location: 'Arlington, VA',
    text: "Locked my keys in the car at the grocery store. They arrived fast, didn't damage my door, and the price was exactly what they quoted upfront.",
    rating: 5
  }];
  return <section id="reviews" className="py-20 bg-white" data-id="element-229">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <span className="inline-block text-primary text-base font-bold tracking-[0.2em] uppercase mb-4" data-id="element-232">
            Reviews
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-secondary" data-id="element-233">
            What Our Neighbors Say
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-234">
          {reviews.map((review, idx) => <div key={idx} className="bg-accent rounded-[10px] p-8 shadow-sm" data-id="element-235">
              <div className="flex gap-1 mb-4" data-id="element-236">
                {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-primary text-primary" data-id="element-237" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-6" data-id="element-238">
                "{review.text}"
              </p>
              <div data-id="element-239">
                <div className="font-bold text-secondary" data-id="element-240">{review.name}</div>
                <div className="text-sm text-gray-500" data-id="element-241">{review.location}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}